/**
 * Lenis smooth scroll — matches reference site inertia behavior.
 * Syncs with GSAP ScrollTrigger when available.
 */
(function () {
  if (typeof Lenis === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var useGsap =
    typeof gsap !== 'undefined' &&
    typeof ScrollTrigger !== 'undefined';

  var lenis = new Lenis({
    autoRaf: !useGsap,
    anchors: true,
    allowNestedScroll: true,
    stopInertiaOnNavigate: true
  });

  window.lenis = lenis;

  if (useGsap) {
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
  }
})();
